import React from "react";
import { motion } from "framer-motion";
import logo1 from "../../Images/Partners/ApPolice-logo.png";
import logo2 from "../../Images/Partners/bharat-biotech-logo.jpg";
import logo3 from "../../Images/Partners/Bhavini-logo.png";
import bobLogo from "../../Images/Partners/Bank-of-Baroda-blogo.png";
import drdoLogo from "../../Images/Partners/drdo-seeklogo.png";
import logo6 from "../../Images/Partners/ICRISAT-logo.png";
import logo7 from "../../Images/Partners/iaf_logo.png";
import logo8 from "../../Images/Partners/IndianNavy.png";
import IOBLogo from "../../Images/Partners/IOBlogo.png";
import logo10 from "../../Images/Partners/NFC.png";
import TelLogo from "../../Images/Partners/logo-new (1).png";
import logo12 from "../../Images/Partners/TGMDC-logo (1).jpg";
import CanaraLogo from "../../Images/Partners/canara-bank-seeklogo.png";
import { useNavigate } from "react-router-dom";

const logos = [
  logo1,
  TelLogo,
  logo2,
  logo3,
  bobLogo,
  drdoLogo,
  logo6,
  logo7,
  logo8,
  IOBLogo,
  logo10,
  logo12,
  CanaraLogo,
];

const Clients = () => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate("/clients");
  };
  return (
    <div className="overflow-hidden bg-bgBlack flex justify-center items-center gap-10 flex-col relative pb-10 ">
      {/* <div className="overflow-hidden bg-bgBlack flex justify-center items-center gap-10 flex-col top-[calc(100vh+0rem)] relative p-10"> */}
      {/* top-[calc(100vh-50px)] */}
      <h2 className="text-3xl text-white  font-bold  text-center ">
        Our Clients
      </h2>
      <div className="w-full flex justify-center">
        <motion.div
          className="flex items-center space-x-8 "
          animate={{ x: ["0%", "-100%"] }}
          transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
        >
          {[...logos, ...logos].map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Client Logo ${index + 1}`}
              onClick={handleNavigation}
              className="object-contain w-44 h-40 shadow-md rounded p-2 border border-lightGray bg-white cursor-pointer transition-transform duration-300 hover:scale-110"
            />
          ))}
        </motion.div>
      </div>
      <button
        className="text-white w-40 text-center bg-lightBlack p-2 hover:underline"
        onClick={handleNavigation}
      >
        View More
      </button>
    </div>
  );
};

export default Clients;
